import React from 'react';
import { BoxIcon } from 'lucide-react';
type Variant = 'primary' | 'secondary' | 'danger';
interface SpellButtonProps {
  spellName: string;
  description: string;
  icon: BoxIcon;
  onClick: () => void;
  variant?: Variant;
  className?: string;
}
export function SpellButton({
  spellName,
  description,
  icon: Icon,
  onClick,
  variant = 'primary',
  className = ''
}: SpellButtonProps) {
  const variants = {
    primary: 'border-[#C9A227] bg-[#F5F0E1] text-[#2C2C2C] hover:bg-[#FFFDF5]',
    secondary: 'border-[#722F37] bg-[#722F37] text-[#F5F0E1] hover:bg-[#8B3A44]',
    danger: 'border-[#8B0000] bg-[#F5F0E1] text-[#8B0000] hover:bg-[#FFF5F5]'
  };
  return <button onClick={onClick} className={`
        relative group flex flex-col items-center justify-center p-4 
        border-2 rounded-xl transition-all duration-300
        active:scale-95 min-h-[140px] w-full
        ${variants[variant]}
        ${className}
      `} data-id="element-74">
      {/* Magical Glow Effect on Hover/Active */}
      <div className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 shadow-[0_0_20px_rgba(201,162,39,0.3)] pointer-events-none" data-id="element-75" />

      <Icon className={`w-8 h-8 mb-3 ${variant === 'secondary' ? 'text-[#C9A227]' : 'text-[#722F37]'}`} data-id="element-76" />

      <span className="font-cinzel font-bold text-lg mb-1 tracking-wide text-center leading-tight" data-id="element-77">
        {spellName}
      </span>

      <span className={`text-xs text-center opacity-80 font-sans ${variant === 'secondary' ? 'text-[#F5F0E1]' : 'text-[#555]'}`} data-id="element-78">
        {description}
      </span>

      {/* Corner Flourishes */}
      <div className={`absolute top-1 left-1 w-2 h-2 border-t-2 border-l-2 ${variant === 'secondary' ? 'border-[#C9A227]' : 'border-[#C9A227]'} opacity-50`} data-id="element-79" />
      <div className={`absolute top-1 right-1 w-2 h-2 border-t-2 border-r-2 ${variant === 'secondary' ? 'border-[#C9A227]' : 'border-[#C9A227]'} opacity-50`} data-id="element-80" />
      <div className={`absolute bottom-1 left-1 w-2 h-2 border-b-2 border-l-2 ${variant === 'secondary' ? 'border-[#C9A227]' : 'border-[#C9A227]'} opacity-50`} data-id="element-81" />
      <div className={`absolute bottom-1 right-1 w-2 h-2 border-b-2 border-r-2 ${variant === 'secondary' ? 'border-[#C9A227]' : 'border-[#C9A227]'} opacity-50`} data-id="element-82" />
    </button>;
}